import React, { useState, useEffect } from 'react';
import QrReader from 'react-qr-reader';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';

import CompleteProcessDialog from '../dialogs/CompleteProcessDialog';
import ProcessingContainer from '../../containers/Processing';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    qrReader: {
      width: 500,
      height: 500,
      background: 'rgba(0, 0, 0, 0.3)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  }),
);

export default (() => {

  const processingContainer = ProcessingContainer.useContainer();
  const [isLoading, setIsLoading] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    processingContainer.clear();
  }, []);

  const handleScan = async (data: any) => {
    if (data) {
      setIsLoading(true);

      var url = new URL(data);
      await processingContainer.loadQRData(url.search.substr(1));

      setIsLoading(false);
    }
  }

  const handleError = (err: any) => {
    console.error(err);
  }

  return (
    <>
      {isLoading || processingContainer.kartes.length > 0 ?
        <div className={classes.qrReader}>
          {isLoading && <CircularProgress />}
        </ div> :
        <QrReader
          delay={300}
          onError={handleError}
          onScan={handleScan}
          /* facingMode={'user'} */
          className={classes.qrReader}
        />
      }
      <CompleteProcessDialog
        karte={processingContainer.kartes.find(karte => true)}
        onClose={() => processingContainer.clear()} />
    </>
  )
}) as React.FC;
